import React, { useEffect } from 'react';
import { DatePicker, Form, Input, Modal, Select } from 'antd';
import dayjs from 'dayjs';

export default function FollowUpEditorModal({
  open,
  followUp,
  users,
  currentUser,
  onCancel,
  onSave,
  t,
}) {
  const [form] = Form.useForm();
  const isEdit = Boolean(followUp?.id);

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue({
      date: followUp?.date ? dayjs(followUp.date) : null,
      action: followUp?.action || '',
      responsible: followUp?.responsible || currentUser?.name || '',
      priority: followUp?.priority || 'Medium',
      status: followUp?.status || 'Pending',
    });
  }, [currentUser?.name, followUp, form, open]);

  const handleSave = async () => {
    const values = await form.validateFields();
    onSave({
      ...followUp,
      date: values.date ? values.date.format('YYYY-MM-DD') : '',
      action: values.action.trim(),
      responsible: values.responsible,
      priority: values.priority || 'Medium',
      status: values.status || 'Pending',
    });
  };

  return (
    <Modal
      title={isEdit ? t('Edit Follow-up') : t('Add Follow-up')}
      open={open}
      onCancel={onCancel}
      onOk={handleSave}
      okText={isEdit ? t('Update') : t('Save')}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="date" label={t('Follow-up date')} rules={[{ required: true, message: t('Please select date') }]}>
          <DatePicker format="DD.MM.YYYY" style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="action" label={t('Description')} rules={[{ required: true, message: t('Date, description, and responsible are required') }]}>
          <Input placeholder={t('Description')} />
        </Form.Item>
        <Form.Item name="responsible" label={t('Responsible')} rules={[{ required: true, message: t('Date, description, and responsible are required') }]}>
          <Select
            showSearch
            optionFilterProp="label"
            options={users.filter((user) => user.active).map((user) => ({ value: user.name, label: user.name }))}
          />
        </Form.Item>
        <Form.Item name="priority" label={t('Priority')}>
          <Select
            options={[
              { value: 'High', label: t('High') },
              { value: 'Medium', label: t('Medium') },
              { value: 'Low', label: t('Low') },
            ]}
          />
        </Form.Item>
        <Form.Item name="status" label={t('Status')}>
          <Select
            options={[
              { value: 'Pending', label: t('Pending') },
              { value: 'Open', label: t('Open') },
              { value: 'In Production', label: t('In Production') },
              { value: 'Done', label: t('Done') },
              { value: 'Not Done', label: t('Not Done') },
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
